import { motion } from "framer-motion";

// Fade-up scroll reveal
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (used in hero + headings)
export const MaskedLines = ({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.1 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden">
        <motion.div
          className={lineClassName}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

// Overline label
export const Overline = ({ children, className = "" }) => (
  <span className={`text-xs md:text-sm font-manrope tracking-[0.25em] uppercase text-gold ${className}`}>
    {children}
  </span>
);
